import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';

import { AuthenticationService } from '../services/auth.service';
import { TokenStorageService } from '../services/token-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private tokenStorageService: TokenStorageService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    const currentUser = this.authenticationService.currentUser();

    if (currentUser) {
      if (currentUser.expiresIn < Math.round(Date.now() / 1000)) {
        return new Promise<boolean>((resolve) => {
          this.authenticationService.refreshToken().subscribe({
            next: (response) => {
              let data = response.data;

              let decodedToken = this.authenticationService.decodeJwtToken(
                data.id_token
              ) as any;

              currentUser.token = data.id_token;
              currentUser.expiresIn = decodedToken.exp;

              this.tokenStorageService.setCurrentUser(currentUser);

              resolve(true);
            },
            error: (error) => {
              this.authenticationService.logout();

              // not logged in so redirect to login page with the return url
              this.router.navigate(['/auth/login'], {
                queryParams: { returnUrl: state.url },
              });

              resolve(false);
            },
          });
        });
      }

      // logged in so return true
      return true;
    }

    this.authenticationService.logout();

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/auth/login'], {
      queryParams: { returnUrl: state.url },
    });

    return false;
  }
}
